import React from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';
const defaultStyles = {};

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function Button({
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  className = null,
  style = defaultStyles,
  active = false,
  disabled = false,
  stretch = 'content',
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '((...args: any...) => any) | undefined'.
  onClick = null,
  href = null,
  target = 'self',
  behavior = 'button',
  size = 'medium',
  type = 'default',
  children,
  ...otherProps
}) {
  // @ts-ignore TS(2533): Object is possibly 'null' or 'undefined'.
  const iconPosition = typeof children[0] === 'string' ? 'right' : 'left';
  const isMobile = bowser.mobile || bowser.tablet;

  const btnClass = classNames(
    className,
    'ws-button',
    `ws-button--${type}`,
    `ws-button--stretch-${stretch}`,
    `ws-button--${size}`,
    {
      'ws-button--disabled': disabled,
      'ws-button--active': active,
      [`ws-button--icon-position-${iconPosition}`]: children.length > 0,
      'ws-button--mobile': isMobile,
    }
  );

  if (behavior === 'label') {
    return (
      // eslint-disable-next-line yola/jsx-a11y/label-has-for
      <label className={btnClass} style={style} {...otherProps}>
        {children}
      </label>
    );
  }

  if (href) {
    if (disabled) {
      return (
        <span className={btnClass} style={style}>
          {children}
        </span>
      );
    }
    return (
      <a
        className={btnClass}
        style={style}
        href={href}
        target={`_${target}`}
        // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string | undefined'.
        onClick={onClick}
        {...otherProps}
      >
        {children}
      </a>
    );
  }
  return (
    // eslint-disable-next-line yola/react/button-has-type
    <button
      className={btnClass}
      disabled={disabled}
      style={style}
      // @ts-ignore TS(2322): Type 'null' is not assignable to type '((...args: any[]) => any) | undefined'.
      onClick={onClick}
      // @ts-ignore TS(2322): Type '"button" | "reset" | "submit" | "label" | AnyString' is not assignable to type '"button" | "reset" | "submit" | undefined'.
      type={behavior}
      {...otherProps}
    >
      {children}
    </button>
  );
}

export default Button;
